import { render, staticRenderFns } from "./OrganizationStudentExamcode.vue?vue&type=template&id=6482ee6c&scoped=true&"
import script from "./OrganizationStudentExamcode.vue?vue&type=script&lang=js&"
export * from "./OrganizationStudentExamcode.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStudentExamcode.vue?vue&type=style&index=0&id=6482ee6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482ee6c",
  null
  
)

export default component.exports